import type { EventFace, GameStatus, Resource, Scenario, TurnPhase } from "./types";

export const RESOURCES: Resource[] = ["hout", "baksteen", "graan", "wol", "erts", "goud"];

export const resourceMeta: Record<Resource, { label: string; shortLabel: string; color: string }> = {
  hout: { label: "Hout", shortLabel: "Hout", color: "#39714e" },
  baksteen: { label: "Baksteen", shortLabel: "Baksteen", color: "#a85138" },
  graan: { label: "Graan", shortLabel: "Graan", color: "#c89622" },
  wol: { label: "Wol", shortLabel: "Wol", color: "#6f9f4d" },
  erts: { label: "Erts", shortLabel: "Erts", color: "#65727a" },
  goud: { label: "Goud", shortLabel: "Goud", color: "#d08d18" },
};

export const scenarioLabels: Record<Scenario, string> = {
  introductie: "Het introductiespel",
  gouden_eeuw: "De Gouden Eeuw",
  tijd_van_conflict: "Een tijd van conflict",
  grote_vooruitgang: "De grote vooruitgang",
  duel_der_vorsten: "Duel der Vorsten",
};

export const scenarioDescriptions: Record<Scenario, string> = {
  introductie: "Alleen het basisspel · 7 zegepunten · ideaal om te leren",
  gouden_eeuw: "Handel, goud en schepen · 12 zegepunten",
  tijd_van_conflict: "Helden, onrust en aanvallen · 12 zegepunten",
  grote_vooruitgang: "Kennis, universiteiten en ontwikkeling · 12 zegepunten",
  duel_der_vorsten: "Alle drie themasets gecombineerd · 13 zegepunten",
};

export const phaseLabels: Record<TurnPhase, string> = {
  startkaarten_kiezen: "Startkaarten kiezen",
  landschappen_ordenen: "Landschappen ordenen",
  wachten_op_worp: "Wachten op dobbelsteenworp",
  actiefase: "Actiefase",
  hand_aanvullen: "Hand aanvullen",
  kaart_ruilen: "Kaart ruilen of beurt afronden",
  keuze_afhandelen: "Keuze afhandelen",
  afgelopen: "Afgelopen",
};

export const statusLabels: Record<GameStatus, string> = {
  wachten_op_tegenstander: "Wachten op tegenstander",
  voorbereiding: "Voorbereiding",
  actief: "Bezig",
  gepauzeerd: "Gepauzeerd",
  afgelopen: "Afgelopen",
};

export const eventLabels: Record<EventFace, string> = {
  roofoverval: "Roofoverval",
  handel: "Handel",
  feest: "Feest",
  goede_oogst: "Goede oogst",
  gebeurtenis: "Gebeurtenis",
};

export const eventDescriptions: Record<EventFace, string> = {
  roofoverval: "Wie meer dan 7 grondstoffen bezit, verliest alle goud- en wolvoorraden.",
  handel: "De speler met het handelsvoordeel neemt 1 grondstof naar keuze van de tegenstander.",
  feest: "Iedere speler krijgt 1 grondstof naar keuze; heeft één speler de meeste vaardigheid, dan krijgt alleen die speler er 1.",
  goede_oogst: "Iedere speler krijgt 1 grondstof naar keuze.",
  gebeurtenis: "De bovenste gebeurteniskaart wordt getrokken, voorgelezen en uitgevoerd.",
};

export function setLabel(set: string): string {
  return (
    {
      basisspel: "Basisspel",
      gouden_eeuw: "De Gouden Eeuw",
      tijd_van_conflict: "Tijd van conflict",
      grote_vooruitgang: "Grote vooruitgang",
    }[set] || set
  );
}
